import '../../../../lib/style/index.less';
// style dependencies
import '../../../../lib/trigger/style';
import './index.less';
